import PropTypes from 'prop-types';
import Link from 'redux-first-router-link';
import styled from 'styled-components';

import { buildArticleLink } from '~/containers/Frontpage/TeaserList/utils';
import { boxShadow, boxShadowHover, colors, layout } from '~/utils/css-mixins';
import media from '~/utils/media';

import ListItemContent from './ListItemContent';

const List = styled.ul`
  display: flex;
  flex-flow: row wrap;
  padding: 0;
  margin: 0;
  list-style: none;

  ${media.phone`
    margin: 0 ${(-1 * layout.oneColumn.pageGutter) / 2}px;
  `}

  ${media.desktop`
    margin: 0 ${(-1 * layout.twoColumn.columnGutters.lg) / 2}px;
  `}

  ${media.giant`
    margin: 0 ${(-1 * layout.twoColumn.columnGutters.xl) / 2}px;
  `}
`;

const ListItem = styled.li`
  flex: 0 0 100%;
  margin-bottom: ${layout.oneColumn.pageGutter}px;

  ${media.phone`
    flex-basis: 50%;
    padding: 0 ${layout.oneColumn.pageGutter / 2}px;
  `}

  ${media.desktop`
    flex-basis: 33.33%;
    padding: 0 ${layout.twoColumn.columnGutters.lg / 2}px;
    margin-bottom: ${layout.twoColumn.columnGutters.lg}px;
  `}

  ${media.giant`
    padding: 0 ${layout.twoColumn.columnGutters.xl / 2}px;
    margin-bottom: ${layout.twoColumn.columnGutters.xl}px;
  `}
`;

const ListItemLink = styled(Link)`
  display: block;
  background-color: #fff;
  color: ${colors.bodyText};
  border-radius: 4px;
  ${boxShadow}
  height: 100%;

  &:hover {
    ${boxShadowHover}
  }
`;

const ArticleList = ({ list, articleType }) => (
  <List>
    {list.map(article => (
      <ListItem key={article.id}>
        <ListItemLink to={buildArticleLink(article)}>
          <ListItemContent
            showAuthor={articleType === 'CHRONICLE'}
            data={article}
          />
        </ListItemLink>
      </ListItem>
    ))}
  </List>
);

ArticleList.propTypes = {
  list: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      slug: PropTypes.string.isRequired,
    }),
  ),
  articleType: PropTypes.oneOf(['CHRONICLE', 'NEWS', 'TV']).isRequired,
};

export default ArticleList;
